export default __webpack_public_path__ + "static/media/Trivia-night-project-screenshot.fae3f0d3.png";